module.exports = __webpack_public_path__ + "static/media/logo-blue-trendex.4965b6b4.png";